import { Button, Form, Input, Select, Space, message  } from 'antd';
import { useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Link } from 'react-router-dom';

const { Option } = Select;


const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};

const tailLayout = {
  wrapperCol: { offset: 8, span: 16 },
};

const CrearObjetos: React.FC = () => {
  const {user} = useAuth0();
  const empresa = user?.id_empresa;
  const [form] = Form.useForm();
  const [buttonLoading, setButtonLoading] = useState(false);
  const { getAccessTokenSilently } = useAuth0();

  const handleAdd = () => {
    setButtonLoading(true);
    form.validateFields().then(async (values) => {
      try {
        const accessToken = await getAccessTokenSilently();
        const response = await fetch(`${process.env.REACT_APP_INSUMOS_URL}/crear_objetos`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`,
          },
          body: JSON.stringify({
            ...values,
            id_empresa: empresa, // Asume que tienes un ID de empresa, ajusta según sea necesario
            tipo: values.tipo
          }),
        });
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        message.success('Objeto añadido correctamente');
        form.resetFields();
      } catch (error) {   
        console.error('Error adding incident:', error);
        message.error('Error al añadir el objeto');
      } finally {
        setButtonLoading(false);
      }
    });
  };



  const onFinish = (values: any) => {
    console.log(values);
  };

  return (
    <Form
      {...layout}
      form={form}
      name="control-hooks"
      onFinish={onFinish}
      style={{ maxWidth: 600}}
    >
      <Form.Item name="descripcion" label="Descripcion" rules={[{ required: true }]}>
        <Input />
      </Form.Item>
      <Form.Item name="tipo" label="Tipo" rules={[{ required: true }]}>
        <Select placeholder="Seleccione una opción">
          <Select.Option value={1}>Grupo</Select.Option>
          <Select.Option value={2}>Subgrupo</Select.Option>
          <Select.Option value={3}>Marca</Select.Option>
        </Select>  
      </Form.Item>
      <Form.Item
        noStyle
        shouldUpdate={(prevValues, currentValues) => prevValues.tipo !== currentValues.tipo}
      >
      </Form.Item>
      <Form.Item {...tailLayout}>
        <Space>
          <Button 
          type="primary" 
          htmlType="submit"
          onClick={handleAdd}
          loading={buttonLoading}
          disabled={buttonLoading}
          >
            {buttonLoading ? 'Guardando...' : 'Guardar'}
          </Button>
          <Button type="default"><Link to= '/listar_objetos'>
            Listar
          </Link>
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
};

export default CrearObjetos;